import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { inviteCodeRegularExpression } from '@nw/shared/utils';

import { YET_TO_BE_DECIDED_UNIVERSITY_VALUE } from '../../constants/ApplicationFeeConstants';
import {
  CATEGORY_OTHER_VALUE,
  RELIGION_OTHER_VALUE
} from '../../constants/ReligionAndCategoryConstants';

export const SeatReservationFeeSectionValidations = (props: {
  t: TFunction;
}) => {
  const { t } = props;
  return Yup.object().shape({
    inviteCode: Yup.string().test(
      'is-valid-invite-code',
      'Enter a valid invite code',
      (value) => !value || inviteCodeRegularExpression.test(value)
    ),
    isEmailCorrect: Yup.string().required(t('validationMessages.required')),
    correctEmail: Yup.string()
      .required(t('validationMessages.required'))
      .email(t('validationMessages.notAValidEmail')),
    preferredUniversity: Yup.string().required(
      t('validationMessages.required')
    ),
    accommodationMode: Yup.string().test(
      'checkValue',
      t('validationMessages.required'),
      (value, values) => {
        if (
          values.options.context.preferredUniversity ===
          YET_TO_BE_DECIDED_UNIVERSITY_VALUE
        ) {
          return true;
        }
        if (Boolean(value)) {
          return true;
        }
        return false;
      }
    ),
    religion: Yup.string().required(t('validationMessages.required')),
    specifyReligion: Yup.string().when('religion', {
      is: RELIGION_OTHER_VALUE,
      then: Yup.string().required(t('validationMessages.required')),
      otherwise: Yup.string().notRequired()
    }),
    category: Yup.string().required(t('validationMessages.required')),
    specifyCategory: Yup.string().when('category', {
      is: CATEGORY_OTHER_VALUE,
      then: Yup.string().required(t('validationMessages.required')),
      otherwise: Yup.string().notRequired()
    }),
    communicationConsent: Yup.bool().oneOf(
      [true],
      t('validationMessages.required')
    ),
    nxtwaveTermsAndConditions: Yup.bool().oneOf(
      [true],
      t('validationMessages.required')
    ),
    nxtwaveRefundPolicy: Yup.bool().oneOf(
      [true],
      t('validationMessages.required')
    )
  });
};
